export default __webpack_public_path__ + "static/media/example_img_1_2.ae99b242.png";